import { useEffect, useState } from 'react'
import CallCenterTable from './callCenterTable'
import { TableWrapper } from '../utils/CallCenterTableWrapper';
import CallCenterDashboardSharedTables from './CallCenterDashboardSharedTables';
import { ITable } from '../utils/commonInterfaces';
import helper from '../utils/helper';
import { message } from 'antd';
import { errorMessage } from '../utils/commonStringsConsts';
import tableHeaderConverter from '../utils/tableHeaderConverter';
import { useParams } from 'react-router-dom';
import CallCenterCutOffAndComments from './CallCenterCutOffAndComments';

export default function CallCenterActivations() {
    const { userId }: { userId: string } = useParams()
    const [documentsTableData, setDocumentsTableData] = useState<ITable>(
        { data: [], columns: [], loading: true }
    );
    const [userLoginLogsTableData, setUserLoginLogsTableData] = useState<ITable>(
        { data: [], columns: [], loading: true, total: 0, currentPage: 1, perPage: 10 }
    );
    const [userStatusLogsTableData, setUserStatusLogsTableData] = useState<ITable>(
        { data: [], columns: [], loading: true, total: 0, currentPage: 1, perPage: 10 }
    );
    const [companyTriggersTableData, setCompanyTriggersTableData] = useState<ITable>(
        { data: [], columns: [], loading: true }
    );

    useEffect(() => {
        getUserStatusLogsData(userStatusLogsTableData.currentPage as number, userStatusLogsTableData.perPage as number);
        getUserLoginLogsData(userLoginLogsTableData.currentPage as number, userLoginLogsTableData.perPage as number);
        getDocumentsData();
        getCompanyTriggersData();
        // eslint-disable-next-line
    }, []);

    const getDocumentsData = async () => {
        try {
            const res: any = await helper.getCallCenterDocumentsData(Number(userId));
            if (res?.status !== 200) {
                message.error(`${errorMessage} with documents data`);
                return
            }
            const data = res?.data?.data
            const formattedData = data.map((item: any) => {
                const mappedItem = {
                    ...item,
                    uploadDate: helper.formatDate(item['uploadDate'], 'MMMM D, YYYY, h:mm A'),
                    link1: item?.urls?.[0],
                    link2: item?.urls?.[1],
                }
                delete mappedItem?.urls
                return mappedItem
            });
            setDocumentsTableData({
                data: formattedData.map((item: any) => ({
                    ...item,
                    link1: item?.link1 ? <a className='text-blue-400' href={item?.link1} download target="_blank" rel="noopener noreferrer">Click Here</a> : null,
                    link2: item?.link2 ? <a className='text-blue-400' href={item?.link2} download target="_blank" rel="noopener noreferrer">Click Here</a> : null,
                })),
                columns: formattedData?.length > 0 ? tableHeaderConverter(formattedData) : [],
                loading: false
            });
        } catch (error) {
            message.error(`${errorMessage} with documents data`);
            setDocumentsTableData((prev) => ({ ...prev, loading: false }));
        }
    }

    const getCompanyTriggersData = async () => {
        try {
            const res: any = await helper.getCallCenterCompanyTriggers(Number(userId));
            if (res?.status !== 200) {
                message.error(`${errorMessage} with company triggers data`);
                return
            }
            const data = res?.data?.data;
            setCompanyTriggersTableData((prev) => ({
                ...prev,
                data,
                columns: data?.length > 0 ? tableHeaderConverter(data) : [],
                loading: false
            }));
        } catch (error) {
            message.error(`${errorMessage} with company triggers data`);
            setCompanyTriggersTableData((prev) => ({ ...prev, loading: false }));
        }
    };
    // Reusable function to fetch data and update table state
    const getPaginatedTableData = async (apiCall: Function, setTableData: React.Dispatch<React.SetStateAction<ITable>>, currentPage: number, perPage: number, type: 'login' | 'status') => {
        try {
            const res: any = await apiCall(Number(userId), currentPage, perPage);
            if (res?.status !== 200) {
                message.error(`${errorMessage} with ${type} logs data`);
                return;
            }
            const data = res?.data?.data;
            const formattedData = data.map((item: any) => ({
                ...item,
                [type === 'login' ? 'time' : 'createdAt']: helper.formatDate(item[type === 'login' ? 'time' : 'createdAt'], 'MMMM D, YYYY, h:mm A')
            }));
            setTableData((prev) => ({
                ...prev,
                data: formattedData,
                columns: data?.length > 0 ? tableHeaderConverter(data) : [],
                loading: false,
                total: res?.data?.total
            }));
        } catch (error) {
            message.error(`${errorMessage} with data`);
            setTableData((prev) => ({ ...prev, loading: false }));
        }
    };

    const getUserLoginLogsData = (page: number, perPage: number) => {
        getPaginatedTableData(helper.getCallCenterUserLoginLogsData, setUserLoginLogsTableData, page, perPage, 'login');
    };

    const getUserStatusLogsData = (page: number, perPage: number) => {
        getPaginatedTableData(helper.getCallCenterUserStatusLogsData, setUserStatusLogsTableData, page, perPage, 'status');
    };

    const handlePagination = ({ current, pageSize }: { current: number, pageSize: number }, type: 'login' | 'status') => {
        if (type === 'login') {
            setUserLoginLogsTableData((prev) => ({ ...prev, currentPage: current, perPage: pageSize, loading: true }));
            getUserLoginLogsData(current, pageSize);
        } else if (type === 'status') {
            setUserStatusLogsTableData((prev) => ({ ...prev, currentPage: current, perPage: pageSize, loading: true }));
            getUserStatusLogsData(current, pageSize);;
        }
    };

    return (
        <>
            <div className="bg-white callCenterMainDashboardHeader">Call Center Dashboard - Activation</div>
            <div className="callCenterMainDashboardContainer">
                {/* <CallCenterDashboardFilter /> */}
                <CallCenterDashboardSharedTables />
                <TableWrapper title='User Status:'>
                    <CallCenterTable
                        columns={userStatusLogsTableData?.columns}
                        rows={userStatusLogsTableData?.data}
                        pagination={{ current: userStatusLogsTableData?.currentPage, pageSize: userStatusLogsTableData?.perPage, total: userStatusLogsTableData?.total }}
                        loading={userStatusLogsTableData?.loading}
                        handleTableChange={(page: { current: number, pageSize: number }) => handlePagination(page, 'status')}
                        scrolling={userStatusLogsTableData?.data?.length ? { x: 'max-content' } : false}
                        title='Call Center: User Status Log'
                    />
                </TableWrapper>
                <TableWrapper title='Login Logs:'>
                    <CallCenterTable
                        columns={userLoginLogsTableData?.columns}
                        rows={userLoginLogsTableData?.data}
                        pagination={{ current: userLoginLogsTableData?.currentPage, pageSize: userLoginLogsTableData?.perPage, total: userLoginLogsTableData?.total }}
                        handleTableChange={(page: { current: number, pageSize: number }) => handlePagination(page, 'login')}
                        loading={userLoginLogsTableData?.loading}
                        scrolling={userLoginLogsTableData?.data?.length ? { x: 'max-content' } : false}
                        title='Call Center: Login_logs'
                    />
                </TableWrapper>
                <div className="unPaginatedTables">
                    <TableWrapper title='Documents Data:'>
                        <CallCenterTable
                            columns={documentsTableData?.columns}
                            rows={documentsTableData?.data}
                            pagination={false}
                            loading={documentsTableData?.loading}
                            scrolling={documentsTableData?.data?.length ? { x: 'max-content' } : { y: 240 }}
                            title='Users Documents Data'
                        />
                    </TableWrapper>
                    <TableWrapper title='Company Triggers:'>
                        <CallCenterTable
                            columns={companyTriggersTableData?.columns}
                            rows={companyTriggersTableData?.data}
                            pagination={false}
                            loading={companyTriggersTableData?.loading}
                            scrolling={companyTriggersTableData?.data?.length ? { x: 'max-content' } : { y: 240 }}
                            title='Company Triggers'
                        />
                    </TableWrapper>
                    <CallCenterCutOffAndComments />
                </div>
            </div>
        </>
    )
}
